var axios = require('axios')
const projectID = require('../../config/firebase').projectId
const databaseId = '(default)' //require('../../config/firebase').databaseId
var googleAPIclient = require('./google')
var scriptFunctions = require('../services/scripts/utilities')
var to = require('await-to-js').default

async function getDocument(userToken, documentPath, query){
      console.log("query", query)
//const email = userCredentials.email
      const bearer = userToken
      return await(axios.post('https://firestore.googleapis.com/v1/projects/'+ projectID + '/databases/' + databaseId + '/documents:runQuery', query, {headers: {
            "Authorization":"Bearer " + oAuth2   
      }}))
}

async function getDocumentByPath(userToken, documentPath){
//const email = userCredentials.email

      const bearer = userToken
      return await(axios.get('https://firestore.googleapis.com/v1/projects/'+ projectID + '/databases/' + databaseId + '/documents/' + documentPath, {headers: {
            "Authorization":"Bearer " + bearer   
      }}))
}


async function createDocument(userToken, collectionID, document){
      console.log(document)
      
      const bearer = userToken
      const url = 'https://firestore.googleapis.com/v1/projects/' + projectID + '/databases/' + databaseId + '/documents/' + collectionID
  //const email = userCredentials.email
        return await(axios.post(url, 
        document, {headers: {
              "Authorization": "Bearer " +  bearer   
        }}))
  }

  async function deleteDocument(userToken,documentPath){
      
      const bearer = userToken
      const url = 'https://firestore.googleapis.com/v1/projects/'  + projectID + '/databases/' + databaseId + '/documents/' + documentPath
  //const email = userCredentials.email
        return await(axios.delete(url,
         {headers: {
              "Authorization": "Bearer " +  bearer
        }}))
  }

  async function updateDocument(userToken, documentPath, body){
        //const documentPath = collectionId + '/' + documentId
      console.log(body)
      
      const bearer = userToken
      let noFields = Object.keys(body.fields).length
      console.log("no fiuelds", noFields)
      const keys = Object.keys(body.fields)
      let url = 'https://firestore.googleapis.com/v1/projects/'  + projectID + '/databases/' + databaseId + '/documents/' + documentPath + '?'
      //unsafe code here
      for(let i = 0; i < noFields; i++){
            
            url += "updateMask.fieldPaths=" + keys[i]
            if (i < noFields - 1){
                url +=  "&"
            }
      }
      
  //const email = userCredentials.email
  console.log("url", url)
        return await(axios.patch(url, 
            body, {headers: {
              "Authorization": "Bearer " +  bearer
        }} ))
  }
  //---------------------------------Utility Functions---------------------
String.prototype.format = function () {
      var i = 0, args = arguments;
      return this.replace(/{}/g, function () {
        return typeof args[i] != 'undefined' ? args[i++] : '';
      });
    };

    
  module.exports = {getDocumentByPath, deleteDocument, getDocument, createDocument, updateDocument}

  //SAMPLE DB GET QUERY
//   const query = {
//     structuredQuery:
//     {
//       from: [
//         {
//           collectionId: collection
//         }
//       ],
//       where: {
//         compositeFilter: {
//           filters: [
//             {
//               fieldFilter: {
//                 field: {
//                   fieldPath: 'userEmail'
//                 },
//                 op: 'EQUAL',
//                 value: {
//                   stringValue: 'john.doe@example.com'
//                 }
//               }
//             }
//           ], op: 'AND' 
//         }
//       }
//     }
//   }


// WEBPACK FOOTER //
// ./src/services/firestore.js